<template>
	<div class="settings-container">
		<div class="settings-layout">
			<!-- 左侧菜单 -->
			<div class="menu-sidebar">
				<div class="menu-list">
					<div
						v-for="item in menus"
						:key="item.index"
						:class="['menu-item', { 'active': activeMenu === item.index }]"
						@click="handleMenuSelect(item.index)"
					>
						<i :class="item.icon"></i>
						<span>{{ item.name }}</span>
					</div>
				</div>
			</div>

			<!-- 右侧内容 -->
			<div class="content-main">
				<div class="content-header">
					<h3 class="title">{{ currentMenu.name }}</h3>
				</div>

				<div class="form-section">
					<!-- 基本信息 -->
					<el-form
						v-if="activeMenu === '0'"
						:model="infoForm"
						:rules="infoRules"
						ref="infoFormRef"
						label-width="100px"
						class="compact-form"
					>
						<el-form-item label="姓名" prop="name">
							<el-input
								v-model="infoForm.name"
								placeholder="请输入姓名"
								maxlength="20"
								class="form-input"
							/>
						</el-form-item>
						<el-form-item label="手机号" prop="phone">
							<el-input
								v-model="infoForm.phone"
								placeholder="请输入手机号"
								maxlength="11"
								class="form-input"
							/>
						</el-form-item>
						<el-form-item class="form-actions">
							<el-button
								type="primary"
								@click="saveInfo"
								:loading="loading"
								class="submit-btn"
							>
								保存
							</el-button>
						</el-form-item>
					</el-form>

					<!-- 密码修改 -->
					<el-form
						v-else
						:model="pwdForm"
						:rules="pwdRules"
						ref="pwdFormRef"
						label-width="100px"
						class="compact-form"
					>
						<el-form-item label="原密码" prop="oldPwd">
							<el-input
								v-model="pwdForm.oldPwd"
								type="password"
								placeholder="请输入原密码"
								show-password
								class="form-input"
							/>
						</el-form-item>
						<el-form-item label="新密码" prop="newPwd">
							<el-input
								v-model="pwdForm.newPwd"
								type="password"
								placeholder="请输入新密码"
								show-password
								class="form-input"
							/>
						</el-form-item>
						<el-form-item label="确认密码" prop="confirmPwd">
							<el-input
								v-model="pwdForm.confirmPwd"
								type="password"
								placeholder="请确认新密码"
								show-password
								class="form-input"
							/>
						</el-form-item>
						<el-form-item class="form-actions">
							<el-button
								type="primary"
								@click="savePwd"
								:loading="loading"
								class="submit-btn"
							>
								修改密码
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		const validateConfirmPwd = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请确认密码'));
			} else if (value !== this.pwdForm.newPwd) {
				callback(new Error('两次输入密码不一致'));
			} else {
				callback();
			}
		};

		return {
			activeMenu: '0',
			loading: false,
			menus: [
				{ index: '0', name: '基本信息', icon: 'el-icon-user' },
				{ index: '1', name: '安全设置', icon: 'el-icon-lock' }
			],
			infoForm: {
				name: '',
				phone: ''
			},
			pwdForm: {
				oldPwd: '',
				newPwd: '',
				confirmPwd: ''
			},
			infoRules: {
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
					{ min: 2, max: 20, message: '姓名长度为2-20个字符', trigger: 'blur' }
				],
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
				]
			},
			pwdRules: {
				oldPwd: [
					{ required: true, message: '请输入原密码', trigger: 'blur' }
				],
				newPwd: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					{ min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
				],
				confirmPwd: [
					{ required: true, validator: validateConfirmPwd, trigger: 'blur' }
				]
			}
		};
	},
	computed: {
		currentMenu() {
			return this.menus.find(item => item.index === this.activeMenu) || {};
		}
	},
	mounted() {
		this.initData();
	},
	methods: {
		initData() {
			const adminInfo = this.$getter('AdminInfo');
			this.infoForm = { ...adminInfo };
		},

		handleMenuSelect(index) {
			this.activeMenu = index;
		},

		async saveInfo() {
			try {
				await this.$refs.infoFormRef.validate();
				this.loading = true;
				
				await this.$put(`sys-admin/${this.$getter('AdminInfo').id}`, this.infoForm);
				this.$vuex('AdminInfo', this.infoForm, true);
				this.$message.success('保存成功');
			} catch (error) {
				if (error.message) this.$message.error(error.message);
			} finally {
				this.loading = false;
			}
		},

		async savePwd() {
			try {
				await this.$refs.pwdFormRef.validate();
				this.loading = true;
				
				const params = {
					original_password: this.pwdForm.oldPwd,
					password: this.pwdForm.newPwd,
					confirm_password: this.pwdForm.confirmPwd
				};
				
				await this.$post('sys-admin-password', params);
				this.$message.success('密码修改成功');
				this.pwdForm = { oldPwd: '', newPwd: '', confirmPwd: '' };
				this.$refs.pwdFormRef.clearValidate();
			} catch (error) {
				if (error.message) this.$message.error(error.message);
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.settings-container {
	background: #fff;
	height: 100vh;
	border-radius: 8px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.settings-layout {
	display: flex;
	height: 100vh;
}

.menu-sidebar {
	width: 220px;
	border-right: 1px solid #f0f0f0;
	background: #fafbfc;
	
	.menu-list {
		padding: 20px 0;
		
		.menu-item {
			display: flex;
			align-items: center;
			padding: 14px 24px;
			color: #606266;
			font-size: 14px;
			cursor: pointer;
			transition: all 0.3s ease;
			border-right: 3px solid transparent;
			
			&:hover {
				color: #409EFF;
				background: rgba(64, 158, 255, 0.05);
			}
			
			&.active {
				color: #409EFF;
				background: rgba(64, 158, 255, 0.08);
				border-right-color: #409EFF;
				font-weight: 500;
			}
			
			i {
				margin-right: 12px;
				font-size: 16px;
				width: 20px;
				text-align: center;
			}
			
			span {
				flex: 1;
			}
		}
	}
}

.content-main {
	flex: 1;
	padding: 0;
	
	.content-header {
		padding: 24px 32px;
		border-bottom: 1px solid #f0f0f0;
		
		.title {
			font-size: 18px;
			font-weight: 600;
			color: #303133;
			margin: 0;
		}
	}
}

.form-section {
	padding: 32px;
	
	.compact-form {
		width: 100%;
		max-width: 480px;
		
		::v-deep .el-form-item {
			margin-bottom: 24px;
			
			.el-form-item__label {
				color: #606266;
				font-weight: 500;
			}
		}
		
		.form-input {
			width: 100%;
			
			::v-deep .el-input__inner {
				height: 40px;
				line-height: 40px;
				border-radius: 6px;
				border: 1px solid #dcdfe6;
				transition: all 0.3s ease;
				
				&:focus {
					border-color: #409EFF;
					box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
				}
			}
		}
		
		.form-actions {
			margin-top: 32px;
			margin-bottom: 0;
			
			.submit-btn {
				width: 120px;
				height: 40px;
				border-radius: 6px;
				font-weight: 500;
				transition: all 0.3s ease;
				
				&:hover {
					transform: translateY(-1px);
					box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
				}
			}
		}
	}
}

// 响应式设计
@media (max-width: 768px) {
	.settings-layout {
		flex-direction: column;
	}
	
	.menu-sidebar {
		width: 100%;
		border-right: none;
		border-bottom: 1px solid #f0f0f0;
		
		.menu-list {
			display: flex;
			padding: 0;
			
			.menu-item {
				flex: 1;
				justify-content: center;
				border-right: none;
				border-bottom: 3px solid transparent;
				
				&.active {
					border-right-color: transparent;
					border-bottom-color: #409EFF;
				}
			}
		}
	}
	
	.form-section {
		padding: 24px 20px;
	}
}
</style>